<template>
    <div>
        <create-customer-form
            v-model="addModal"
            @success="customerCreated"
            ref="createCustomerModalRef"
            @cancel="hideModal()"
        ></create-customer-form>

        <import-customer-form
            v-model="importModal"
            @success="customerImported"
            ref="importCustomerModalRef"
            @cancel="hideModal()"
        ></import-customer-form>

        <customer-table title="Warehouse" ref="customertableRef">
            <b-button-group class="float-right">
                <b-button
                    variant="primary"
                    v-show="user_permissions.includes('create.customers')"
                    @click="addModal = true"
                    >Add Customer</b-button
                >
                <b-button
                    variant="primary"
                    @click="importModal = true"
                    v-show="user_permissions.includes('create.customers')"
                    >Import Customers</b-button
                >
                <b-button
                    variant="primary"
                    @click="exportContacts()"
                    v-show="user_permissions.includes('view.customers')"
                    >Export Customers</b-button
                >
            </b-button-group>
        </customer-table>
    </div>
</template>
<script>
import CustomerTable from './CustomerTable'
import CreateCustomerForm from './CreateCustomerForm'
import ImportCustomerForm from './ImportCustomerForm'

import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'customers',
    components: {
        CustomerTable,
        CreateCustomerForm,
        ImportCustomerForm,
    },
    mixins: [popupMixins],
    data: () => {
        return {
            addModal: false,
            importModal: false,
        }
    },
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        hideModal() {
            this.$refs.customertableRef.doSearch()
        },

        customerCreated() {
            this.addModal = false
            this.doToast('Customer Action!', 'Customer Created.', 'success')
            this.$refs.customertableRef.doSearch()
        },
        customerImported() {
            this.addModal = false
            this.doToast('Customer Action!', 'Customer Imported.', 'success')
            this.$refs.customertableRef.doSearch()
        },
        exportContacts() {
            this.$refs.customertableRef.showDetailsDialog()
        },
    },
}
</script>
<style></style>
